<template>
    <div class="as-selector muti" :class="{ 'as-selector--clearable': clearable }" @mouseover="onMouseover" @mouseleave="onMouseleave">
        <div class="as-selector__label">{{label}}<slot name="label"></slot></div>
        <div class="as-selector__value">
            {{viewValue ? viewValue.name : placeholder}}
            <template v-if="mutiple && value && value.length > 1">+{{ value.length - 1 }}</template>
        </div>
        <span class="as-selector__clear" v-if="clearable" @click.stop="onClear">
            <as-icon name="qingchu1" v-show="viewValue"></as-icon>
        </span>
        <div class="as-selector__option_wrap" v-if="hover">
            <ul class="as-selector__option_list">
                <li class="as-selector__option" :class="{ 'active': mutiple && selectValueList.includes(item.value) }" v-for="(item,key) in options" :key="item.value" @click="onItemClicked(key)">{{item.name}}</li>
                <li v-if="showEmptyVisible && (!options || options.length == 0)" class="as-selector__option">{{ emptyText }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
    import AsIcon from '@/components/icon'
    export default {
        name: 'AsSelector',
        components: {
            AsIcon
        },
        props: {
            label: String,
            default: Object,
            options: Array,
            mutiple: Boolean,
            clearable: Boolean,
            showEmptyVisible: {
                type: Boolean,
                default: false
            },
            emptyText: {
                type: String,
                default: "暂无数据"
            },
            placeholder: {
                type: String,
                default: '请选择'
            }
        },
        data(){
            return {
                value:null,
                hover:false,
                selectListData: [],
            }
        },
        computed: {
            viewValue() {
                const value = this.value || this.default;
                if (this.mutiple) {
                    return value ? value[0] : null;
                } else {
                    return value;
                }
            },
            selectValueList() {
                return this.value ? this.value.map(item => item.value) : [];
            }
        },
        methods:{
            onMouseover: function(){
                this.hover = true;
            },
            onMouseleave: function(){
                this.hover = false;
            },
            onItemClicked(key) {
                const selectData = this.options[key];
                if (this.mutiple) {
                    if (this.value) {
                        const index = this.value.findIndex(item => item.value === selectData.value);
                        if (index === -1) {
                            this.value.push(selectData);
                        } else {
                            this.value.splice(index, 1);
                        }
                    } else {
                        this.value = [selectData];
                    }
                } else {
                    this.value = this.options[key];
                    this.hover = false;
                }
                this.$emit('change',this.value);
            },
            onClear() {
                this.value = null;
                this.$emit('change',this.value);
                this.$emit('clear');
            },
        },
    }
</script>

<style lang="scss">
.as-selector {
    height: 30px;
    line-height: 30px;
    border-radius: 4px;
    background-color: #FFF;
    display: inline-flex;
    padding: 0 25px 0 10px;
    margin-right: 8px;
    position: relative;
    min-width: 180px;
    cursor: default;
    font-size: 12px;
    &--clearable {
        padding-right: 30px;
        .as-selector__value {
            max-width: 100px;
        }
    }
}
.as-selector:hover{
    box-shadow: rgba(0,0,0,0.3) 1px 1px 3px;
    position: relative;
    z-index: 9999;
    .as-selector__clear {
        display: block;
    }
}
.as-selector__label{
    padding-right: 10px;
    color: #7E7E7E;
}
.as-selector__label::after{
    content: "";
    border-right: 1px solid #DADADA;
    position: relative;
    left: 5px;
}
.as-selector::after{
    content: "";
    position: absolute;
    right: 10px;
    top: 14px;
    border-top: 4px solid #FFF;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-bottom: none;
}
.as-selector::before{
    position: absolute;
    right: 7px;
    top: 8px;
    content: "";
    width: 14px;
    height: 14px;
    border-radius: 8px;
    background-color: #D8D8D8;
}
.as-selector__clear {
    display: none;
    position: absolute;
    top: 50%;
    right: 25px;
    font-size: 16px;
    transform: translateY(-50%);
    cursor: pointer;
    color: #D8D8D8;
}
.as-selector__value{
    max-width: 150px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.as-selector__option_wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 29px;
}
.as-selector__option_list{
    margin-top: 5px;
    width: 100%;
    border-radius: 4px;
    background-color: #FFF;
    box-shadow: rgba(0,0,0,0.3) 1px 1px 3px;
    max-height: 300px;
    overflow-y: auto;
}
.as-selector__option{
    line-height: 20px;
    padding: 5px 10px;
    cursor: pointer;
}
.as-selector__option:hover,
.as-selector__option.active {
    background-color: #D8D8D8;
}
</style>